export default __webpack_public_path__ + "static/media/PDF.1df627c6.svg";